import { memo, useMemo } from 'react';
import { Drawer, styled } from '@mui/material';
import { useSelector, useDispatch } from 'react-redux';

import { selectDrawer } from 'store/entities/drawer/selectors';
import { FilterDrawer } from './Containers/Filter';
import { setDrawer } from 'store/entities/drawer/actions';
import { isMobileApp } from 'utils/common';

export enum DrawerContentType {
  FILTER_DRAWER = 'FILTER',
}

const StyledDrawer = styled(Drawer)({
  width: '360px',
  flexShrink: 0,
  '& .MuiDrawer-paper': {
    width: '360px',
    boxSizing: 'border-box',
    position: 'fixed',
    height: '100%',
    border: '0px',
    // This is necessary due to the other MUI components having as well hardcoded zIndex
    zIndex: 12000,
  },
});

const drawerContentMap: Record<DrawerContentType, React.ComponentType> = {
  [DrawerContentType.FILTER_DRAWER]: FilterDrawer,
};

export const DrawerWrapper = memo(() => {
  const dispatch = useDispatch();
  const drawer = useSelector(selectDrawer());
  const mobileApp = isMobileApp();

  const handleClose = () => {
    dispatch(
      setDrawer({
        isOpen: false,
        contentType: null,
        dataSchema: null,
        entity: '',
      })
    );
  };

  const renderContent = useMemo(() => {
    if (!drawer?.contentType) return null;

    const ContentComponent = drawerContentMap[drawer.contentType];
    return ContentComponent ? <ContentComponent /> : null;
  }, [drawer]);

  return (
    <StyledDrawer
      anchor="right"
      open={drawer?.isOpen}
      onClose={handleClose}
      variant={mobileApp ? 'temporary' : 'persistent'}
      {...(mobileApp ? { disableScrollLock: true } : {})}>
      {renderContent}
    </StyledDrawer>
  );
});
